import AppDataService from "./AppDataService";

const COMMON_BASE = 'Resubmit'

export default class ResubmitDataService {

    static async getFederalResubmitGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFederalResubmitGridData`, { params });
    }

    static async getFederalResubmitReferenceList() {
        return await AppDataService.get(`${COMMON_BASE}/GetReferences`)
    }

    static async federalResubmitFormsExportToExcel(params) {
        return await AppDataService.get(`${COMMON_BASE}/ResubmitFormsExportToExcel`, { params })
    }

    static async federalResubmitFormsExportToExcelForAll(params) {
        return await AppDataService.get(`${COMMON_BASE}/ResubmitFormsExportToExcelforAll`, { params })
    }

    static async federalResubmitViewPDF(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetResubmitPdf`, { params })
    }

    static async getStateResubmitGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStateResubmitGridData`, { params })
    }

    static async resubmitToState(data) {
        return await AppDataService.put(`${COMMON_BASE}/ResubmitToState`, data);
    }

    static async getStateResubmitPayersList(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayers`, { params })
    }

    static async getReconPayersList() {
        return await AppDataService.get(`${COMMON_BASE}/GetReconPayers`);
    }

    static async getReconResubmitGridData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconResubmitGridData`, { params });
    }

    static async resubmitToIRS(data) {
        return await AppDataService.put(`${COMMON_BASE}/ResubmitToIRS`, data)
    }

    static async resubmitRecon(data) {
        return await AppDataService.put(`${COMMON_BASE}/ResubmitRecon`, data)
    }

    static async updateAccountNumber({ CorrectedAccountNumber, StateReference, formId }) {
        return await AppDataService.put(`${COMMON_BASE}/UpdateAccountNumber?CorrectedAccountNumber=${CorrectedAccountNumber}&StateReference=${StateReference}&formId=${formId}`,)
    }

    static async getStatePayrollStateNames() {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollStates`);
    }

    static async getStatePayrollFormNames(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormNames?stateName=${params}`)
    }

    static async getStatePayrollPayerNames(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollResubmitPayers?statePayrollFormId=${params}`)
    }

    static async getStatePayrollResubmitGridData({ payer, taxYear, formId }) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollResubmitGridData?payer=${payer}&taxYear=${taxYear}&formId=${formId}`)
    }

    static async resubmitToStatePayroll(data) {
        return await AppDataService.put(`${COMMON_BASE}/ResubmitToStatePayroll`, data);
    }
}